import { clearStickers } from '../api/generationStickers'
import { PENDING_GENERATION_KEY } from '../pages/generate/utils/constants'

/**
 * Забыть идущие генерации этого браузера при выходе из аккаунта: снимок студии и виджета, записи операций Suno и
 * Mureka (`*_pending_v1`), стопку стикеров. С «Ждём ответа нейросети» (27.09) запись с номером генерации живёт до
 * ответа сервера, и следующий человек на этом компьютере унаследовал бы чужие генерации — как настройку звука
 * (utils/autoSound). Сами генерации это не трогает: сервер их доведёт, результат ляжет в «Мои генерации».
 */
/** Чьи записи о генерациях лежат в этом браузере — id пользователя (как sub в токене). */
const PENDING_OWNER_KEY = 'pending_generations_owner'

export function pendingOwner(): string | null {
	try {
		return localStorage.getItem(PENDING_OWNER_KEY)
	} catch {
		return null
	}
}

/**
 * Вошёл пользователь: записи другого человека на этом компьютере — забыть, свои — оставить (ревью 27.09). Сессия
 * могла кончиться без выхода (ответ 401 уводит на вход), и в ту же вкладку мог войти другой: его сессия не должна
 * доводить и показывать чужие генерации. Ожидания, поднятые из записей до входа, сверяют хозяина (pollUntil).
 */
export function claimPendingGenerations(userId: string | null | undefined): void {
	if (!userId) return
	try {
		const prev = localStorage.getItem(PENDING_OWNER_KEY)
		if (prev && prev !== userId) forgetPendingGenerations()
		localStorage.setItem(PENDING_OWNER_KEY, userId)
	} catch {
		/* хранилище недоступно — забывать нечего */
	}
}

export function forgetPendingGenerations(): void {
	try {
		localStorage.removeItem(PENDING_GENERATION_KEY)
		localStorage.removeItem(PENDING_OWNER_KEY)
		for (let i = localStorage.length - 1; i >= 0; i--) {
			const key = localStorage.key(i)
			if (key && key.endsWith('_pending_v1')) localStorage.removeItem(key)
		}
	} catch {
		/* хранилище недоступно — забывать нечего */
	}
	clearStickers()
}
